export default __webpack_public_path__ + "static/media/SWT0190.34I-27390_-16467_0.c2abf95a.jpg";